import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { Link } from 'react-router-dom'

import { useSettingsStore, useTimerStore } from 'stores'
import { useGoogleAppdata } from 'hooks'

import {
  Main,
  SelectField,
  SwitchField,
  Heading,
  Button,
} from 'components'

dayjs.extend(localizedFormat)

const Settings = () => {
  const settings = useSettingsStore()
  const timers = useTimerStore(state => state.timers)
  const { save } = useGoogleAppdata()
  
  return (
    <Main center>
      <Heading>Settings</Heading>

      <SwitchField
        label="Show confetti when a countdown finishes"
        value={settings.showConfetti}
        onChange={value => {
          settings.setShowConfetti(value)
          save()
        }}
        id="show_confetti"
      />

      <SwitchField
        label="Show seconds"
        value={settings.showSeconds}
        onChange={value => {
          settings.setShowSeconds(value)
          save()
        }}
        id="show_seconds"
      />

      <SwitchField
        label="Use grid layout"
        value={settings.useGridLayout}
        onChange={value => {
          settings.setUseGridLayout(value)
          save()
        }}
        id="use_grid_layout"
      />

      <SelectField
        label="Color scheme"
        options={{
          system: 'Follow system',
          light: 'Light mode',
          dark: 'Dark mode',
        }}
        value={settings.theme}
        onChange={value => {
          settings.setTheme(value)
          save()
        }}
        id="color_scheme"
      />

      <SelectField
        label="Date format"
        options={{
          'LLL': dayjs().format('LLL'),
          'L LT': dayjs().format('L LT'),
          'LLLL': dayjs().format('LLLL'),
        }}
        value={settings.dateFormat}
        onChange={value => {
          settings.setDateFormat(value)
          save()
        }}
        id="date_format"
      />

      <Heading as="h2">Manage your data</Heading>
      <Button
        secondary
        fullwidth
        as='a'
        href={`data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(timers.map(t => ({
          ...t,
          id: undefined,
        })), null, 2))}`}
        download={`Era_export_${dayjs().format('YYYY-MM-DD')}.json`}
      >Export your countdowns</Button>
      <div style={{ height: '.7em' }} />
      <Button
        secondary
        fullwidth
        as={Link}
        to="/import"
      >Import countdowns from a file</Button>
    </Main>
  )
}

export default Settings